import { Outlet } from 'react-router-dom'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { useFilters } from 'modules/surveys/hooks/useFilteredQuestionGroups'
import { useSurveyShowContext } from 'modules/surveys/pages/Show/hooks'
import type QuestionGroup from 'modules/surveys/store/models/QuestionGroup'

interface Props {
  surveyId: number
  questionGroups: QuestionGroup[]
}

function SurveyShowWrapper({ surveyId, questionGroups }: Props) {
  const { survey, form, canEditSurvey, updateCanBeStarted } = useSurveyShowContext()
  const { access } = useCurrentSession()
  const filteredGroup = useFilters(questionGroups, surveyId, access.id).get()
  const groupFiltered =
    filteredGroup && survey
      ? filteredGroup.filter((el) => el.attributes.cycle_id === survey.currentCycleId)
      : []

  const group = groupFiltered[groupFiltered.length - 1]

  const { loading } = useAsyncData(async () => {
    if (canEditSurvey) updateCanBeStarted()
  }, [surveyId])

  return <Outlet context={{ form, survey, group, loading }} />
}

export default observer(SurveyShowWrapper)
